module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_le_11_22_07_on.3bc06aac.svg";